import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  id: "kt_create_account_stepper",
  ref: "horizontalWizardRef",
  class: "stepper stepper-links"
}
const _hoisted_4 = { class: "stepper-nav row" }
const _hoisted_5 = {
  class: "stepper-item current col first",
  "data-kt-stepper-element": "nav"
}
const _hoisted_6 = { class: "stepper-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "stepper-step" }, "1", -1)
const _hoisted_8 = {
  class: "stepper-item col",
  "data-kt-stepper-element": "nav"
}
const _hoisted_9 = { class: "stepper-title" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "stepper-step" }, "2", -1)
const _hoisted_11 = {
  class: "stepper-item col",
  "data-kt-stepper-element": "nav"
}
const _hoisted_12 = { class: "stepper-title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "stepper-step" }, "3", -1)
const _hoisted_14 = {
  class: "stepper-item col last",
  "data-kt-stepper-element": "nav"
}
const _hoisted_15 = { class: "stepper-title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "stepper-step" }, "4", -1)
const _hoisted_17 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_18 = { class: "w-100" }
const _hoisted_19 = { class: "fv-row mb-10" }
const _hoisted_20 = { class: "form-label required" }
const _hoisted_21 = { class: "fv-row mb-10" }
const _hoisted_22 = { class: "form-label required" }
const _hoisted_23 = { class: "row mb-10" }
const _hoisted_24 = { class: "col mb-10" }
const _hoisted_25 = { class: "form-label required" }
const _hoisted_26 = { class: "col mb-10" }
const _hoisted_27 = { class: "form-label required" }
const _hoisted_28 = { class: "fv-row" }
const _hoisted_29 = { class: "form-label required" }
const _hoisted_30 = { "data-kt-stepper-element": "content" }
const _hoisted_31 = { class: "d-block w-100" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h3", null, "Créez votre questionnaire", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "pt-4" }, " Pour créer votre questionnaire, vous pouvez choisir des questions de la questiothèque (banque de questions organisées par thématique et validées par Obea, notre partenaire externe) ou ajouter une question personnalisée si aucune question de la questiothèque ne correspond à votre besoin. C’est à vous ! ", -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = {
  key: 0,
  class: "card bg-success bg-opacity-25 h-100 mt-3"
}
const _hoisted_38 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-3 me-3 text-gray-900" }, null, -1)
const _hoisted_42 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-900 m-0",
  href: "#"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = {
  key: 1,
  class: "card bg-info bg-opacity-25 h-100 mt-3"
}
const _hoisted_45 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-3 me-3 text-gray-900" }, null, -1)
const _hoisted_49 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-900 m-0",
  href: "#"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = {
  id: "add_system_question",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = { class: "modal-title" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", {
  "aria-label": "Close",
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_57 = { class: "modal-body pt-0" }
const _hoisted_58 = { class: "p-5 mt-5 mb-5 bg-primary bg-opacity-25 rounded" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = { class: "form-control form-control-solid" }
const _hoisted_62 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_63 = { class: "col" }
const _hoisted_64 = {
  class: "btn btn-primary btn-light",
  type: "submit"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("button", {
  class: "ms-3 btn btn-icon btn-light btn-active-light-primary",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo fs-7 pt-1" })
], -1)
const _hoisted_66 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_67 = { class: "mb-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-3 me-3 text-gray-900" }, null, -1)
const _hoisted_69 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-900 m-0",
  href: "#"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_71 = { class: "fw-bold mt-3 w-100 text-end" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  id: "add_custom_question",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_74 = { class: "modal-dialog modal-panel-right" }
const _hoisted_75 = { class: "modal-content" }
const _hoisted_76 = { class: "modal-body" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col question-column light-background" }
const _hoisted_79 = { class: "mb-4" }
const _hoisted_80 = { class: "form-label required" }
const _hoisted_81 = { class: "mb-4" }
const _hoisted_82 = { class: "form-label required" }
const _hoisted_83 = { class: "mb-4" }
const _hoisted_84 = { class: "form-label required" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("div", {
    "aria-label": "Close",
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_88 = /*#__PURE__*/_createStaticVNode("<div data-kt-stepper-element=\"content\"><div class=\"card bg-primary bg-opacity-25 h-100 mt-3\"><div class=\"card-body\"><div class=\"m-4\"> Télécharger la population cible de l’enquête Pulse : <button class=\"btn btn-primary btn-sm\">Upload</button></div><div class=\"m-4\">Vous pouvez enregistrer l’enquête et télécharger votre fichier avec les collaborateurs à interroger dans un second temps</div></div></div></div>", 1)
const _hoisted_89 = { class: "d-flex flex-stack pt-15" }
const _hoisted_90 = { class: "mr-2" }
const _hoisted_91 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_92 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_93 = {
  key: 1,
  class: "btn btn-lg btn-primary",
  type: "submit"
}
const _hoisted_94 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.$t("pages.surveyadd.step1")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.$t("pages.surveyadd.step2")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h3", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(_ctx.$t("pages.surveyadd.step3")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(_toDisplayString(_ctx.$t("pages.surveyadd.step4")), 1)
            ])
          ])
        ]),
        _createElementVNode("form", {
          id: "kt_create_account_form",
          class: "mx-auto w-100 pt-15 pb-10",
          novalidate: "novalidate",
          onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("pages.surveyadd.surveylabel")), 1),
                _createVNode(_component_Field, {
                  id: "label",
                  modelValue: this.survey.label,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.survey.label) = $event)),
                  class: "form-control form-control-lg",
                  name: "label",
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("pages.surveyadd.surveydescription")), 1),
                _createVNode(_component_Field, {
                  modelValue: this.survey.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.survey.description) = $event)),
                  as: "textarea",
                  class: "form-control form-control-lg",
                  name: "description"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("pages.surveyadd.date_begin")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.survey.date_begin) = $event)),
                    class: "form-control form-control-lg",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, this.survey.date_begin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("pages.surveyadd.date_end")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.survey.date_end) = $event)),
                    class: "form-control form-control-lg",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, this.survey.date_end]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("pages.surveyadd.languages")), 1),
                _createVNode(_component_el_select, {
                  modelValue: this.survey.languages,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.survey.languages) = $event)),
                  "allow-create": "",
                  class: "w-100",
                  "default-first-option": "",
                  filterable: "",
                  multiple: "",
                  placeholder: "Choose tags for your target"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Français",
                      value: "fr"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Anglais",
                      value: "anglais"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _createElementVNode("button", {
                    class: "btn btn-primary me-3 w-25",
                    "data-bs-target": "#add_custom_question",
                    "data-bs-toggle": "modal",
                    onClick: _cache[5] || (_cache[5] = 
                                            (e) => {
                                                e.preventDefault();
                                            }
                                        )
                  }, _toDisplayString(_ctx.$t("pages.surveyadd.addcustomquestion")), 1),
                  _createElementVNode("button", {
                    class: "btn btn-primary-inverse w-25",
                    "data-bs-target": "#add_system_question",
                    "data-bs-toggle": "modal",
                    onClick: _cache[6] || (_cache[6] = 
                                            (e) => {
                                                e.preventDefault();
                                            }
                                        )
                  }, _toDisplayString(_ctx.$t("pages.surveyadd.addsystemquestion")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.selectedQuestions, (question) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: question.question,
                    class: "col-12 mt-5"
                  }, [
                    (!question.is_custom)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_39, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.thematic, (thematic) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: thematic.name,
                                    innerHTML: thematic.name
                                  }, null, 8, _hoisted_40))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_41,
                                _createElementVNode("a", _hoisted_42, _toDisplayString(question.question), 1),
                                _hoisted_43
                              ]),
                              _createElementVNode("i", null, "Answers : " + _toDisplayString(question.answers), 1)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_46, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.thematic, (thematic) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: thematic.name,
                                    innerHTML: thematic.name
                                  }, null, 8, _hoisted_47))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_48,
                                _createElementVNode("a", _hoisted_49, _toDisplayString(question.question), 1),
                                _hoisted_50
                              ]),
                              _createElementVNode("i", null, "Answers : " + _toDisplayString(question.answers), 1)
                            ])
                          ])
                        ]))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("h5", _hoisted_55, _toDisplayString(_ctx.$t("pages.surveyadd.addsystemquestion")), 1),
                      _hoisted_56
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("select", _hoisted_61, [
                              _createElementVNode("option", _hoisted_62, _toDisplayString(_ctx.$t("pages.surveyadd.thematics")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.thematics, (thematic) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: thematic.name
                                }, _toDisplayString(thematic.name), 1))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("button", _hoisted_64, _toDisplayString(_ctx.$t("general.search")), 1),
                            _hoisted_65
                          ])
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.ecchoQuestions, (question) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: question.question,
                          class: "card bg-success bg-opacity-25 h-50 mt-3"
                        }, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_67, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.thematic, (thematic) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: thematic.name,
                                    class: "badge-light badge text-primary me-3"
                                  }, _toDisplayString(thematic.name), 1))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_68,
                                _createElementVNode("a", _hoisted_69, _toDisplayString(question.question), 1),
                                _hoisted_70
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("a", {
                                class: "btn btn-success btn-sm btn-light btn-active-light-success",
                                onClick: 
                                                                (e) => {
                                                                    e.preventDefault();
                                                                    this.addToSelectedQuestion(question);
                                                                }
                                                            
                              }, _toDisplayString(_ctx.$t("pages.surveyadd.add")), 9, _hoisted_72)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("pages.surveyadd.addcustomquestion")), 1),
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("pages.surveyadd.thematics")), 1),
                            _createVNode(_component_el_select, {
                              modelValue: this.question.thematics,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.question.thematics) = $event)),
                              "allow-create": "",
                              class: "w-100",
                              "default-first-option": "",
                              filterable: "",
                              multiple: "",
                              placeholder: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Environnement de travail",
                                  value: "evt"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Management",
                                  value: "mgt"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("pages.surveyadd.question")), 1),
                            _createVNode(_component_el_input, {
                              id: "question",
                              modelValue: this.question.question,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.question.question) = $event)),
                              name: "label",
                              type: "text"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("pages.surveyadd.type")), 1),
                            _createVNode(_component_el_select, {
                              modelValue: this.question.type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.question.type) = $event)),
                              "allow-create": "",
                              class: "w-100",
                              "default-first-option": "",
                              filterable: "",
                              placeholder: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionType, (type) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: type.value,
                                    label: type.value,
                                    value: type.name
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        _hoisted_85,
                        _hoisted_86
                      ])
                    ]),
                    _hoisted_87
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_88,
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("button", {
                class: "btn btn-lg btn-light-primary me-3",
                "data-kt-stepper-action": "previous",
                type: "button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
              }, [
                _createElementVNode("span", _hoisted_91, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("general.back")), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-lg btn-primary me-3",
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formSubmit()))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("general.done")) + " ", 1),
                    _createElementVNode("span", _hoisted_92, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("button", _hoisted_93, [
                    _createTextVNode(_toDisplayString(_ctx.$t("general.next")) + " ", 1),
                    _createElementVNode("span", _hoisted_94, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
            ])
          ])
        ], 32)
      ], 512)
    ])
  ]))
}